// Totale gerarchico: se almeno una sottocommessa è visibile somma quelle (+ quota propria della madre se visibile), altrimenti la madre aggregata.
export function hierTotal(all, visible, get) {
  const vis = new Set(visible);
  const groups = [];
  let cur = null;
  all.forEach((row) => {
    if (!row.is_sub) { cur = { parent: row, children: [] }; groups.push(cur); }
    else if (cur) cur.children.push(row);
    else groups.push({ parent: null, children: [row] });
  });
  return groups.reduce((s, g) => {
    const visKids = g.children.filter((c) => vis.has(c));
    const kidsSum = visKids.reduce((a, c) => a + (get(c) || 0), 0);
    if (!g.parent) return s + kidsSum;
    if (!vis.has(g.parent)) return s + kidsSum;
    if (visKids.length === 0) return s + (get(g.parent) || 0);
    const own = (get(g.parent) || 0) - g.children.reduce((a, c) => a + (get(c) || 0), 0);
    return s + own + kidsSum;
  }, 0);
}
